export enum Entity {
  USER = 'user',
  INSTALLER = 'installer',
  INSTALLER_DETAILS = 'installer-detail',
  DISTRIBUTOR = 'distributor',
  COUNTRY_ADMINISTRATOR = 'country_administrator',
  LEAD = 'lead',
  TRANSLATION = 'translation',
  PROFILE = 'profile',
}
